"use client";

import { useNavigationSound } from "@/app/hooks/useNavigationSound";

export default function NavigationSoundProvider({ children }) {
  useNavigationSound();

  return children;
}
